/** Canonical Team1..TeamN slot keys for trade comparisons. */
export function normalizeTeamSlot(name) {
  if (!name) return "";
  const m = String(name).trim().match(/^Team\s*(\d+)$/i);
  if (m) return `Team${parseInt(m[1], 10)}`;
  return String(name).trim();
}

export function teamSlotsMatch(a, b) {
  if (!a || !b) return false;
  return normalizeTeamSlot(a) === normalizeTeamSlot(b);
}

/** Extra drops needed after trade if roster would exceed cap (not counting trade outgoing). */
export function tradeRequiredDropCount(rosterSize, outgoingCount, incomingCount, rosterCap) {
  const postTradeSize = rosterSize - outgoingCount + incomingCount;
  return Math.max(0, postTradeSize - rosterCap);
}

export function getTradeDropRequirements(trade, teamRosters, rosterMax) {
  const fromKey = normalizeTeamSlot(trade.from);
  const toKey = normalizeTeamSlot(trade.to);
  const fromRoster = teamRosters[trade.from] || teamRosters[fromKey] || [];
  const toRoster = teamRosters[trade.to] || teamRosters[toKey] || [];
  const offerN = (trade.offer || []).length;
  const requestN = (trade.request || []).length;
  const rawFromRequired = tradeRequiredDropCount(fromRoster.length, offerN, requestN, rosterMax);
  const rawToRequired = tradeRequiredDropCount(toRoster.length, requestN, offerN, rosterMax);
  const storedFromDrops = (trade.from_drop_player_ids || []).length;
  const storedToDrops = (trade.to_drop_player_ids || []).length;
  return {
    fromRequired: Math.max(0, rawFromRequired - storedFromDrops),
    toRequired: Math.max(0, rawToRequired - storedToDrops),
  };
}

export function tradeDropCandidates(trade, teamRosters, side) {
  const team = side === "from" ? trade.from : trade.to;
  const outgoing = side === "from" ? trade.offer || [] : trade.request || [];
  const teamKey = normalizeTeamSlot(team);
  const roster = teamRosters[team] || teamRosters[teamKey] || [];
  const outgoingSet = new Set(outgoing.map((id) => String(id)));
  return roster.filter((p) => !outgoingSet.has(String(p.player_id || p.id)));
}

